import React, { useState, useEffect } from "react";
import { TextField, ThemeProvider, createTheme } from "@mui/material";
import { Fragment, useMemo, useRef } from "react";
import {
  useAsyncDebounce,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import { Link } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import { common_axios } from "../../../App";
import { Form, Formik, useFormik, Field, FieldArray } from "formik";
import * as yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../../components/Loader";
import Backdrop from "@mui/material/Backdrop";
import DeleteIcon from "@mui/icons-material/Delete";
import { InputAdornment, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { withRouter } from "react-router-dom";
import RuleIcon from "@mui/icons-material/Rule";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import SettingsBackupRestoreRoundedIcon from "@mui/icons-material/SettingsBackupRestoreRounded";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import PersonIcon from "@mui/icons-material/Person";
// import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
const initialValues = {
  friends: [
    {
      attribute: "",
      values: "",
      operations: "",
      conditions: null,
    },
  ],
};

const SignupSchema = yup.object().shape({
  values: yup
    .string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("required"),
});
const MediumMaster = () => {
  const Reset = () => {
    window.location.reload();
  };

  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
          // "&$error": {
          //   color: "#db3131",
          // },
        },
      },
    },
  });

  const [operations1, setOperations1] = useState("");
  const [open, setOpen] = useState();
  const [data, setData] = useState([]);
  const [response, setResponse] = useState(2);
  const [smsresponse, setSmsResponse] = useState(1);
  const [condition3, setCondition3] = useState("");
  const [validitySelect, setValiditySelect] = useState("Day");
  const [volumeSelect, setVolumeSelect] = useState("GB");
  const [priceSelect, setPriceSelect] = useState("Paisa");
  const [langSelect, setLangSelect] = useState("ENG");
  const [mediumIdSelect, setmediumIdSelect] = useState(2);
  const [baseRateRadioSelect, setBaseRateRadioValue] = useState("");
  const [display, setdisplay] = useState("d-none");
  const [display2, setdisplay2] = useState("d-none");
  const [selectedUserDetail, setSelectedUserDetail] = useState(undefined);
  const [selectVerifyDocuments, setSelectVerifyDocuments] = useState(undefined);
  const [selectUnblockDetails, setSelectUnblockDetails] = useState(undefined);
  const [selectUserDetailsBlock, setSelectUserDetailsBlock] =
    useState(undefined);
  const [rejectedReasonValues, setRejectedReasonValues] = useState(undefined);
  const [approveValues, setApproveValues] = useState(undefined);
  const [openTextfield, setOpenTextField] = useState({});
  const [roleTypes, setRoleTypes] = useState("");
  const [finalPriceA, setFinalPriceA] = useState("");
  const [finalPriceD, setFinalPriceD] = useState("");
  const [shirtVeer, setshirtVeer] = useState(false);
  const [totaldis, setTotalDis] = useState(0);
  const [totalAdon, setTotalAdon] = useState(0);

  console.log("operations1------", operations1);
  const [value01, setValue01] = useState(null);
  // console.log("condition2-----", condition2);
  const roleType = JSON.parse(localStorage.getItem("Sidebaritems"));
  // .....................................Formik............................................//

  console.log({ shirtVeer });
  const initialValues = {
    values: "",
    values1: "",
    values2: "",
    values3: "",
    values4: "",
    ruleName: "",
    description: "",
  };
  const formik = useFormik({
    initialValues: initialValues,

    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    // validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (mediumIdSelect == 2) {
        try {
          const res = await common_axios.post(
            `http://192.168.167.66:5050/admin/v1/channel/create`,
            {
              mediumId: mediumIdSelect,
              name: values.Name,
              price: String(values.price + " " + priceSelect),
              volume: String(values.volume + " " + volumeSelect),
              validity: String(values.Validity + " " + validitySelect),
            }
          );

          console.log("check", Number(localStorage.getItem("UserId")));
          if (res.data.statusDescription.statusCode == 200) {
            setshirtVeer(true);
            // formik.resetForm;
            // GetMedium();
            toast.success(res.data.statusDescription.statusMessage, {
              theme: "colored",
            });
            setOpen(false);
          } else {
            setOpen(false);
            toast.error(res.data.statusDescription.statusMessage, {
              theme: "colored",
            });
          }
        } catch (error) {
          console.log(error);
          await toast.error("Something went wrong", {
            theme: "colored",
          });
        }
      } else {
        try {
          if (baseRateRadioSelect == "discountRate") {
            const res = await common_axios.post(
              `http://192.168.167.66:5050/admin/v1/channel/create`,
              {
                name: values.Name,
                userId: Number(localStorage.getItem("UserId")),
                validity: String(values.Validity + " " + validitySelect),
                mediumId: mediumIdSelect,
                noOfMsg: values.noOfMsg,
                language: langSelect,
                noOfChar: values.noOfChar,
                baseRate: values.baseRate, // addOnRate: values.addOnRate,
                discountRate: values.discountRate,
              }
            );
            if (res.data.statusDescription.statusCode == 200) {
              setshirtVeer(true);
              // GetMedium();

              toast.success(res.data.statusDescription.statusMessage, {
                theme: "colored",
              });
              setOpen(false);
            } else {
              setOpen(false);
              toast.error(res.data.statusDescription.statusMessage, {
                theme: "colored",
              });
            }
          } else if (baseRateRadioSelect == "addOnRate") {
            const res = await common_axios.post(
              `http://192.168.167.66:5050/admin/v1/channel/create`,
              {
                name: values.Name,
                userId: Number(localStorage.getItem("UserId")),
                validity: String(values.Validity + " " + validitySelect),
                mediumId: mediumIdSelect,
                noOfMsg: values.noOfMsg,
                noOfChar: values.noOfChar,
                language: langSelect,
                noOfChar: values.noOfChar,
                addOnRate: values.addOnRate,
                baseRate: values.baseRate,
                // discountRate: values.discountRate,
              }
            );
            if (res.data.statusDescription.statusCode == 200) {
              // GetMedium();
              toast.success(res.data.statusDescription.statusMessage, {
                theme: "colored",
              });
              setshirtVeer(true);
              setOpen(false);
            } else {
              setOpen(false);
              toast.error(res.data.statusDescription.statusMessage, {
                theme: "colored",
              });
            }
          }
          setTotalDis((baseRate) => values.baseRate - values.discountRate);
          setTotalAdon((baseRate1) => values.baseRate + values.addOnRate);
          const finalpricewithdisc = values.baseRate - values.addOnRate;
          const finalpricewithadon = values.baseRate + values.addOnRate;
          console.log("finalpriced", finalpricewithdisc);
          console.log("finalpriceadon", finalpricewithadon);
          setFinalPriceD(finalpricewithadon);
          setFinalPriceA(finalpricewithadon);
          const unblockUserModal = async (cell) => {
            // console.log(cell.row.original);
            await setSelectUnblockDetails(cell?.row?.original);
            await unblockUser?.current?.click();
          };

          console.log("aaa", langSelect);
          console.log("check", Number(localStorage.getItem("UserId")));
          // if (res.data.statusDescription.statusCode == 200) {
          //   GetMedium();
          //   toast.success(res.data.statusDescription.statusMessage, {
          //     theme: "colored",
          //   });
          //   setOpen(false);
          // } else {
          //   setOpen(false);
          //   toast.error(res.data.statusDescription.statusMessage, {
          //     theme: "colored",
          //   });
          // }
        } catch (error) {
          console.log(error);
          await toast.error("Something went wrong", {
            theme: "colored",
          });
        }
      }
    },
  });

  const userid = Number(localStorage.getItem("UserId"));
  // async function GetMedium() {
  //   try {
  //     const result = await common_axios.get(
  //       "http://192.168.167.66:5050/admin/v1/medium/list"
  //     );
  //     console.log("DATA", result);
  //     console.log("DATA2", result.data.mediumList[0].id);
  //     if (result.data.statusDescription.statusCode == 200) {
  //       if (mediumIdSelect == 2) {
  //         setData(result.data.mediumList[1].channelList);
  //       } else {
  //         setData(result.data.mediumList);
  //       }
  //       setOpen(false);
  //     } else {
  //       setOpen(false);
  //     }
  //   } catch (error) {
  //     // console.log(error);
  //     setOpen(false);
  //     toast.error("Please check your network");
  //   }
  // }

  // useEffect(() => {
  //   GetMedium();
  // }, []);

  useEffect(() => {
    if (baseRateRadioSelect == "discountRate") {
      setdisplay("");
      setdisplay2("d-none");
    } else if (baseRateRadioSelect == "addOnRate") {
      setdisplay2("");
      setdisplay("d-none");
    } else {
      setdisplay2("d-none");
      setdisplay("d-none");
    }
  }, [baseRateRadioSelect]);

  const validityResponse = (e) => setValiditySelect(e.target.value);
  const volumeResponse = (e) => setVolumeSelect(e.target.value);
  const priceResponse = (e) => setPriceSelect(e.target.value);
  const MediumIdResponse = (e) => setmediumIdSelect(e.target.value);
  const LangResponse = (e) => setLangSelect(e.target.value);
  const BaseRateRadioResponse = (e) => setBaseRateRadioValue(e.target.value);
  const modalAddUser = useRef(null);
  const modalAddUserClose = useRef(null);
  const modelButtonRejectClose = useRef();

  const addUsermodal = () => {
    // alert("Form is valid!");

    modalAddUser.current.click();
  };
  console.log("res-----", response);
  console.log("dis", typeof finalPriceD, finalPriceD);
  console.log("ado", finalPriceA);
  const columns = useMemo(
    () => [
      {
        Header: "userId",
        Footer: "userId",
        accessor: "userId",
      },
      {
        Header: "Name",
        Footer: "name",
        accessor: "name",
      },
      {
        Header: "Price",
        Footer: "price",
        accessor: "price", // accessor is the "key" in the data
      },
      {
        Header: "Volume",
        Footer: "volume",
        accessor: "volume",
      },
      {
        Header: "Validity",
        Footer: "validity",
        accessor: "validity",
      },
      {
        Header: "Status",
        Footer: "Status",
        accessor: "response",
        Cell: (cell) => (
          <div className="">
            <button
              className="btn color_1  "
              type="button"
              id="dropdownMenuButton1"
              aria-expanded="false"
            >
              {console.log("aaa", cell.row.original.approved)}
              {cell.row.original.approved == 1 ? (
                <>
                  <span class="badge bg-success activated_1">success</span>
                </>
              ) : (
                <>
                  <span class="badge bg-danger activated_1">Pending</span>
                </>
              )}

              {/* <DeleteIcon /> */}
            </button>
          </div>
        ),
      },

      {
        Header: "Action",
        Footer: "Action",
        accessor: "action",
        Cell: (cell) => {
          console.log({ cell });
          return (
            <div className="dropdown">
              <button
                className="btn color_1 dropdown-toggle"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="material-icons opacity-10 size">person</i>
              </button>
              {console.log("celldata", cell.row.original.status)}
              {cell.row.original.approved == 0 ? (
                <>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li
                      onClick={() => {
                        console.log(cell, "hello");
                      }}
                    >
                      <a
                        className="dropdown-item "
                        onClick={() => {
                          rejectUserModal(cell);
                        }}
                      >
                        <i class="fa fa-ban me-2" aria-hidden="true"></i>
                        Reject Channel
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        // onClick={() => {
                        //   approveUserModal(cell);
                        // }}
                        onClick={approvalChannelapi}
                      >
                        <i class="fa fa-thumbs-up me-2" aria-hidden="true"></i>
                        Approve User
                      </a>
                    </li>
                  </ul>
                </>
              ) : cell.row.original.approved == 2 ? (
                <>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    {/* <li className="dropdown-item">
                      <Link
                        to={`/dashboard/UserDetail/${cell.row.original.uid}`}
                      >
                        View Details
                      </Link>
                    </li> */}
                  </ul>
                </>
              ) : (
                <></>
              )}
            </div>
          );
        },

        disableFilters: true,
      },
    ],
    []
  );

  const unblockUser = useRef(null);
  const modelButtonReject = useRef(null);
  const modelButtonApprove = useRef(null);
  const modelEditUser = useRef(null);
  // console.log(Status, "lalalaallalas");

  const editApprovedModal = async (cell) => {
    await setSelectUserDetailsBlock(cell.row.original);
    // await setSelectedUserDetailApprove(cell.row.original);
    await modelEditUser.current?.click();
  };
  editApprovedModal();
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,

    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,

      data,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );

  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  // console.log("condition-----", condition);

  const removeConditionData3 = () => {
    setCondition3("");
    // setHideCondition3(true);
  };

  // const removeConditionData4 = () => {
  //   setCondition4("");
  //   setHideCondition4(true);
  // };

  const rejectUserModal = async (cell) => {
    await setRejectedReasonValues(cell.row.original.id);
    await setSelectedUserDetail(cell.row.original);
    await modelButtonReject.current.click();
  };

  console.log({ rejectedReasonValues });
  console.log({ approveValues });
  // console.log(cell.row.original.id);

  // const approveUserModal = async (cell) => {
  //   await setApproveValues(cell.row.original.id);
  //   await setSelectedUserDetail(cell.row.original);
  //   await modelButtonApprove.current.click();
  //   // await setSelectVerifyDocuments(cell.row.original);
  // };

  const [age, setAge] = React.useState("");
  const rejectChannelapi = async (e, cell) => {
    e.preventDefault();
    try {
      setOpen(true);

      const res = await common_axios.post(
        `http://192.168.167.66:5050/admin/v1/admin/channel/approve/action`,
        {
          action: "reject",
          // channelId: 8,
          channelId: rejectedReasonValues,

          userId: Number(localStorage.getItem("UserId")),
          reason:
            selectedUserDetail.rejectedReason == "Other"
              ? selectedUserDetail.rejectedReasonText
              : selectedUserDetail.rejectedReason,
        }
      );

      if (res.data.statusDescription.statusCode == 200) {
        await modalAddUser.current.click();
        // fetchUser();
        setOpen(false);
        // await setStatus("approved");
        await toast.success("User has been rejected", {
          theme: "colored",
          // toastId: customId1,
          // toastId: customId1,
        });
      } else {
        setOpen(false);
        await toast.error(res.data.statusDescription.description, {
          theme: "colored",
          // toastId: /,
        });
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      await toast.error("Something went wrong", {
        theme: "colored",
        // toastId: customId1,
        // toastId: customId1,
      });
    }
  };
  const approvalChannelapi = async (e, cell) => {
    // alert("approve");
    e.preventDefault();
    try {
      setOpen(true);

      const res = await common_axios.post(
        `http://192.168.167.66:5050/admin/v1/admin/channel/approve/action`,
        {
          action: "approve",
          channelId: approveValues,
          userId: Number(localStorage.getItem("UserId")),
        }
      );
      console.log("first", cell.row.original);

      if (res.data.statusDescription.statusCode == 200) {
        await modalAddUser.current.click();
        // fetchUser();
        setOpen(false);
        // await setStatus("approved");
        await toast.success("User has been approved", {
          theme: "colored",
          // toastId: customId1,
          // toastId: customId1,
        });
      } else {
        setOpen(false);
        await toast.error(res.data.statusDescription.description, {
          theme: "colored",
          // toastId: /,
        });
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      await toast.error("Something went wrong", {
        theme: "colored",
        // toastId: customId1,
        // toastId: customId1,
      });
    }
  };

  console.log("ccc", MediumIdResponse);
  console.log("sss", Number(totaldis));
  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <div>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open}
          >
            <Loader />
          </Backdrop>
        </div>
        {selectedUserDetail != undefined && (
          <div>
            <button
              ref={modelButtonReject}
              type="button"
              className="btn btn-primary d-none"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop1"
            >
              Launch static backdrop modal
            </button>
            <form onSubmit={rejectChannelapi}>
              <div
                className="modal fade"
                id="staticBackdrop1"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex="-1"
                aria-labelledby="staticBackdrop1Label"
                aria-hidden="true"
              >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="staticBackdrop1Label">
                        Channel Master
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>

                    <div className="modal-body">
                      <div className="row">
                        <div className="col-md-6">
                          <label className="fw-bold mt-3 w-100">
                            Reason for Rejection :
                            <select
                              required
                              className="form-select mt-2"
                              name="reason"
                              id="reason"
                              onChange={(e) => {
                                if (e.target.value == "Other") {
                                  selectedUserDetail.rejectedReasonText = "";
                                }
                                setSelectedUserDetail({
                                  ...selectedUserDetail,
                                  rejectedReason: e.target.value,
                                });
                              }}
                            >
                              <label
                                id="reason"
                                name="reason"
                                selected="true"
                                hidden
                                disabled
                              >
                                Please Select
                              </label>
                              <option value="Incorrect User Information">
                                Incorrect User Information
                              </option>
                              <option value="Not Valid Pack">
                                Not Valid Pack
                              </option>
                              <option value="Incorrect ">Incorrect</option>

                              <option value="Other">Other</option>
                            </select>
                            {selectedUserDetail.rejectedReason == "Other" && (
                              <input
                                required
                                className="form-control mt-2"
                                placeholder="Rejected Reason Here"
                                type="text"
                                value={selectedUserDetail.rejectedReasonText}
                                onChange={(e) => {
                                  setSelectedUserDetail({
                                    ...selectedUserDetail,
                                    rejectedReasonText: e.target.value,
                                  });
                                }}
                              />
                            )}
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="modal-footer">
                      <button
                        ref={modelButtonRejectClose}
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary"
                        // disabled={
                        //   selectedUserDetail.rejectedReason == "Other" ||
                        //   selectedUserDetail.rejectedReason
                        // }
                        // data-bs-dismiss="modal"
                      >
                        Reject User
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        )}
        {shirtVeer == true ? (
          <div>
            <button
              ref={modalAddUser}
              type="button"
              className="btn btn-primary d-none"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop1"
            >
              Launch static backdrop modal
            </button>

            <div
              className="modal fade"
              id="staticBackdrop1"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabindex="-1"
              aria-labelledby="staticBackdrop1Label"
              aria-hidden="true"
            >
              <form>
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="staticBackdrop1Label">
                        Final Price
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>

                    <div className="modal-body">
                      <div className="row">
                        <div className="col-md-6">
                          {/* {console.log("dd", Number(totaldis))}
                          {console.log("ee", Number(totalAdon))}
                          {console.log("ff", totalAdon == NaN)} */}
                          {baseRateRadioSelect == "discountRate"
                            ? totaldis != NaN && (
                                <p>Total price :- {Number(totaldis)}</p>
                              )
                            : totalAdon != NaN && (
                                <p>Total price :- {Number(totalAdon)}</p>
                              )}
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                        ref={modalAddUserClose}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        ref={modalAddUserClose}
                        class="btn btn-primary"
                        data-bs-dismiss="modal"
                        // data-bs-dismiss="modal"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        ) : (
          <>.</>
        )}
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-12 col-sm-12 mb-xl-0 mb-4">
              <div className="card mb-3 mt-4">
                <ThemeProvider theme={theme}>
                  <div className="card-body">
                    <form onSubmit={formik.handleSubmit} novalidate>
                      <div className="card shadow-none border bg_blue mb-5">
                        <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                          ADD MEDIUM MASTER
                        </span>

                        <div className="row mt-4">
                          <div className="col mt-auto ">
                            <div className="col-md-2 btn  w_btn m-0 me-4">
                              <FormControl required fullWidth size="small">
                                <InputLabel id="demo-simple-select-autowidth-label">
                                  Medium
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-autowidth-label"
                                  id="demo-simple-select-autowidth"
                                  value={mediumIdSelect}
                                  onChange={MediumIdResponse}
                                  // autowidth
                                  label="Medium"
                                >
                                  <MenuItem value={2}>Data</MenuItem>
                                  <MenuItem value={3}>SMS</MenuItem>
                                  {/* <MenuItem value="false">OBD</MenuItem>
                                  <MenuItem value="false">SMS Insert</MenuItem> */}
                                </Select>
                              </FormControl>
                            </div>
                          </div>
                        </div>
                        <div className="card-body text-lg-start text-center">
                          <div className="row mt-4" id="row">
                            <div className="col-md-3">
                              <TextField
                                autoComplete="on"
                                className="ms-4 w-75"
                                type="text"
                                label="Name"
                                name="Name"
                                variant="outlined"
                                size="small"
                                required
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <Tooltip
                                        title="Name"
                                        placement="top"
                                        arrow
                                        sx={{ color: "#85CBF2" }}
                                      >
                                        <InfoIcon />
                                      </Tooltip>
                                    </InputAdornment>
                                  ),
                                }}
                                onChange={formik.handleChange}
                                value={formik.values.Name}
                                error={
                                  formik.touched.ruleName &&
                                  Boolean(formik.errors.Name)
                                }
                                helperText={
                                  formik.touched.Name && formik.errors.Name
                                }
                              />
                            </div>
                            {/* <div className="col-md-3"> */}
                            {/* <div className="col-md-2"> */}
                            {response == 2 ? (
                              <div className="col-md-3">
                                <div className="d-flex" id="vald_slct">
                                  <TextField
                                    autoComplete="on"
                                    className="ms-4 w-75"
                                    type="number"
                                    label="Validity"
                                    // placeholder="Enter Validity"
                                    name="Validity"
                                    variant="outlined"
                                    size="small"
                                    required
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end"></InputAdornment>
                                      ),
                                    }}
                                    onChange={formik.handleChange}
                                    value={formik.values.Validity}
                                    error={
                                      formik.touched.Validity &&
                                      Boolean(formik.errors.Validity)
                                    }
                                    helperText={
                                      formik.touched.Validity &&
                                      formik.errors.Validity
                                    }
                                  />

                                  {/* <div className="row mt-3"> */}
                                  <FormControl required fullWidth size="small">
                                    {/* <InputLabel id="demo-simple-select-autowidth-label"></InputLabel> */}
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={validitySelect}
                                      onChange={validityResponse}
                                      label="validity"
                                    >
                                      <MenuItem value="Day">Day</MenuItem>
                                      <MenuItem value="Month">Month</MenuItem>
                                      <MenuItem value="Year">Year</MenuItem>
                                    </Select>
                                  </FormControl>
                                  {/* </div> */}
                                </div>
                              </div>
                            ) : (
                              <></>
                            )}
                            {/* </div> */}
                            {mediumIdSelect == 2 ? (
                              <div className="col-md-3">
                                <div className="d-flex" id="vald_slct">
                                  <TextField
                                    autoComplete="on"
                                    className="ms-4 w-75"
                                    type="text"
                                    label="Volume"
                                    name="volume"
                                    variant="outlined"
                                    size="small"
                                    required
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end"></InputAdornment>
                                      ),
                                    }}
                                    onChange={formik.handleChange}
                                    value={formik.values.volume}
                                    error={
                                      formik.touched.volume &&
                                      Boolean(formik.errors.volume)
                                    }
                                    helperText={
                                      formik.touched.volume &&
                                      formik.errors.volume
                                    }
                                  />

                                  {/* <div className="row mt-3"> */}
                                  <FormControl required fullWidth size="small">
                                    {/* <InputLabel id="demo-simple-select-autowidth-label"></InputLabel> */}
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={volumeSelect}
                                      onChange={volumeResponse}
                                      label="volume"
                                    >
                                      <MenuItem value="GB">GB</MenuItem>
                                      <MenuItem value="MB">MB</MenuItem>
                                    </Select>
                                  </FormControl>
                                  {/* </div> */}
                                </div>
                              </div>
                            ) : (
                              <></>
                            )}
                            {mediumIdSelect == 2 ? (
                              <div className="col-md-3">
                                <div className="d-flex" id="vald_slct">
                                  <TextField
                                    autoComplete="on"
                                    className="ms-4 w-75"
                                    type="text"
                                    label="Price"
                                    name="price"
                                    variant="outlined"
                                    size="small"
                                    required
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end"></InputAdornment>
                                      ),
                                    }}
                                    onChange={formik.handleChange}
                                    value={formik.values.price}
                                    error={
                                      formik.touched.price &&
                                      Boolean(formik.errors.price)
                                    }
                                    helperText={
                                      formik.touched.price &&
                                      formik.errors.price
                                    }
                                  />

                                  {/* <div className="row mt-3"> */}
                                  <FormControl required fullWidth size="small">
                                    {/* <InputLabel id="demo-simple-select-autowidth-label"></InputLabel> */}
                                    <Select
                                      // labelId="demo-simple-select-autowidth-label"
                                      // id="demo-simple-select-autowidth"
                                      value={priceSelect}
                                      onChange={priceResponse}
                                      label="price"
                                    >
                                      <MenuItem value="Paisa">Paisa</MenuItem>
                                      <MenuItem value="Dollar">Dollar</MenuItem>
                                      <MenuItem value="Rupees">Rupees</MenuItem>
                                    </Select>
                                  </FormControl>
                                  {/* </div> */}
                                </div>
                              </div>
                            ) : (
                              <></>
                            )}
                            {mediumIdSelect == 2 ? (
                              <></>
                            ) : (
                              <>
                                <div className="col-md-3">
                                  <FormControl required fullWidth size="small">
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                      Language
                                    </InputLabel>
                                    <Select
                                      // labelId="demo-simple-select-autowidth-label"
                                      // id="demo-simple-select-autowidth"
                                      value={langSelect}
                                      onChange={LangResponse}
                                      label="Language"
                                    >
                                      <MenuItem value="BAN">BAN</MenuItem>
                                      <MenuItem value="ENG">ENG</MenuItem>
                                    </Select>
                                  </FormControl>
                                </div>
                              </>
                            )}
                            {/* <div className="row mt-3"> */}
                          </div>
                        </div>
                        <div className="card-body text-lg-start text-center">
                          <div className="row mt-3" id="row">
                            {mediumIdSelect == 2 ? (
                              <></>
                            ) : (
                              <>
                                {/* <div className="row mt-4"> */}
                                {/* <div className="col-md-3">
                                  <FormControl required fullWidth size="small">
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                      Language
                                    </InputLabel>
                                    <Select
                                      // labelId="demo-simple-select-autowidth-label"
                                      // id="demo-simple-select-autowidth"
                                      value={langSelect}
                                      onChange={LangResponse}
                                      label="Language"
                                    >
                                      <MenuItem value="BAN">BAN</MenuItem>
                                      <MenuItem value="ENG">ENG</MenuItem>
                                    </Select>
                                  </FormControl>
                                </div> */}
                                {/* </div> */}
                              </>
                            )}

                            {mediumIdSelect == 2 ? (
                              <></>
                            ) : (
                              <div className="col-md-2">
                                <TextField
                                  autoComplete="on"
                                  className="ms-4 w-75"
                                  type="text"
                                  label="No. of Message"
                                  name="noOfMsg"
                                  variant="outlined"
                                  size="small"
                                  required
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <Tooltip
                                          title="No. of Message"
                                          placement="top"
                                          arrow
                                          sx={{ color: "#85CBF2" }}
                                        >
                                          <InfoIcon />
                                        </Tooltip>
                                      </InputAdornment>
                                    ),
                                  }}
                                  onChange={formik.handleChange}
                                  value={formik.values.noOfMsg}
                                  error={
                                    formik.touched.noOfMsg &&
                                    Boolean(formik.errors.noOfMsg)
                                  }
                                  helperText={
                                    formik.touched.noOfMsg &&
                                    formik.errors.noOfMsg
                                  }
                                />
                              </div>
                            )}
                            {mediumIdSelect == 2 ? (
                              <></>
                            ) : (
                              <div className="col-md-2">
                                <TextField
                                  autoComplete="on"
                                  className="ms-4 w-75"
                                  type="text"
                                  label="No. of Char"
                                  name="noOfChar"
                                  variant="outlined"
                                  size="small"
                                  required
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <Tooltip
                                          title="No. of Char"
                                          placement="top"
                                          arrow
                                          sx={{ color: "#85CBF2" }}
                                        >
                                          <InfoIcon />
                                        </Tooltip>
                                      </InputAdornment>
                                    ),
                                  }}
                                  onChange={formik.handleChange}
                                  value={formik.values.noOfChar}
                                  error={
                                    formik.touched.noOfChar &&
                                    Boolean(formik.errors.noOfChar)
                                  }
                                  helperText={
                                    formik.touched.noOfChar &&
                                    formik.errors.noOfChar
                                  }
                                />
                              </div>
                            )}
                            {mediumIdSelect == 3 ? (
                              <div className="col-md-2">
                                <div className="d-flex" id="vald_slct">
                                  <TextField
                                    autoComplete="on"
                                    className="ms-4 w-75"
                                    type="number"
                                    label="Base Rate"
                                    name="baseRate"
                                    variant="outlined"
                                    size="small"
                                    required
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end"></InputAdornment>
                                      ),
                                    }}
                                    onChange={formik.handleChange}
                                    value={formik.values.baseRate}
                                    error={
                                      formik.touched.baseRate &&
                                      Boolean(formik.errors.baseRate)
                                    }
                                    helperText={
                                      formik.touched.baseRate &&
                                      formik.errors.baseRate
                                    }
                                  />

                                  {/* <div className="row mt-3"> */}

                                  {/* </div> */}
                                </div>
                              </div>
                            ) : (
                              <></>
                            )}
                            {mediumIdSelect == 3 ? (
                              <div className="col-md-3" id="radio">
                                <FormControl>
                                  {/* <FormLabel id="demo-controlled-radio-buttons-group">
                                    BaseRate
                                  </FormLabel> */}
                                  <RadioGroup
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    value={baseRateRadioSelect}
                                    onChange={BaseRateRadioResponse}
                                  >
                                    <FormControlLabel
                                      value="discountRate"
                                      control={<Radio />}
                                      label="Discount"
                                    />
                                    <FormControlLabel
                                      value="addOnRate"
                                      control={<Radio />}
                                      label="addOnRate"
                                    />
                                  </RadioGroup>
                                </FormControl>
                              </div>
                            ) : (
                              <></>
                            )}

                            {mediumIdSelect == 3 ? (
                              <div className={`col-md-2 ${display}`}>
                                <div className="d-flex">
                                  <TextField
                                    // autoComplete="on"
                                    className="ms-4 w-75"
                                    type="number"
                                    label="Discount"
                                    name="discountRate"
                                    variant="outlined"
                                    size="small"
                                    // required
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end"></InputAdornment>
                                      ),
                                    }}
                                    onChange={formik.handleChange}
                                    value={formik.values.discountRate}
                                    // error={
                                    //   formik.touched.discountRate &&
                                    //   Boolean(formik.errors.discountRate)
                                    // }
                                    helperText={
                                      formik.touched.discountRate &&
                                      formik.errors.discountRate
                                    }
                                  />

                                  {/* <div className="row mt-3"> */}

                                  {/* </div> */}
                                </div>
                              </div>
                            ) : (
                              <></>
                            )}
                            {mediumIdSelect == 3 ? (
                              <div className={`col-md-2 ${display2}`}>
                                <div className="d-flex">
                                  <TextField
                                    // autoComplete="on"
                                    className="ms-4 w-75"
                                    type="number"
                                    label="addOnRate"
                                    name="addOnRate"
                                    variant="outlined"
                                    size="small"
                                    // required
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end"></InputAdornment>
                                      ),
                                    }}
                                    onChange={formik.handleChange}
                                    value={formik.values.addOnRate}
                                    // error={
                                    //   formik.touched.addOnRate &&
                                    //   Boolean(formik.errors.addOnRate)
                                    // }
                                    helperText={
                                      formik.touched.addOnRate &&
                                      formik.errors.addOnRate
                                    }
                                  />
                                </div>
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                          <div className="mt-4 text-sm text-end">
                            <button
                              onClick={addUsermodal}
                              type="submit"
                              // type="reset"
                              // onClick={formik.resetForm}
                              className="btn bg-gradient-primary mt-4 me-4 w_btn"
                            >
                              Submit
                              <i className="material-icons opacity-10">
                                arrow_right_alt
                              </i>
                            </button>

                            <button
                              style={{ marginLeft: "6px" }}
                              type="reset"
                              onClick={formik.resetForm}
                              className="btn bg-gradient-secondary m-0 ms-2"
                            >
                              Reset
                              <i className="material-icons opacity-10">
                                settings_backup_restore
                              </i>
                            </button>
                            {/* {console.log("disss", finalPriceD)} */}
                          </div>
                          {/* <p>Total Price :-{finalPriceD}</p> */}
                        </div>
                      </div>
                    </form>
                    <div className="text-end mt-2">
                      <p> Want to See Channel details </p>
                      <Link
                        to="/dashboard/ViewPackage"
                        style={{ color: "#63B7E6", marginLeft: "30px" }}
                      >
                        <span>Click here !!!</span>
                      </Link>
                    </div>
                    {/* <div className="p-4">
                      <div className="d-flex justify-content-between">
                        <table
                          {...getTableProps()}
                          id="example"
                          className="table table-striped table-bordered dataTable table-sm"
                          style={{ width: "100%" }}
                        >
                          <thead>
                            {headerGroups.map((headerGroup) => (
                              <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                  <th
                                    {...column.getHeaderProps(
                                      column.getSortByToggleProps()
                                    )}
                                    className="text-center width_2"
                                  >
                                    {column.render("Header")}
                                    <span>
                                      {column.isSorted
                                        ? column.isSortedDesc
                                          ? "↑"
                                          : "↓"
                                        : ""}
                                    </span>
                                  </th>
                                ))}
                              </tr>
                            ))}
                          </thead>
                          <tbody {...getTableBodyProps()}>
                            {page.map((row) => {
                              prepareRow(row);
                              return (
                                <tr {...row.getRowProps()}>
                                  {row.cells.map((cell) => {
                                    return (
                                      <td
                                        {...cell.getCellProps()}
                                        className="text-center"
                                      >
                                        {cell.render("Cell")}
                                      </td>
                                    );
                                    // MediumMaster;
                                  })}
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>

                      <div class="d-flex justify-content-between">
                        <div>
                          <span>
                            Page:
                            <strong>
                              {pageIndex + 1} of {pageOptions.length}
                            </strong>
                          </span>

                          <span>
                            | Go to Page :{""}
                            <input
                              type="number"
                              defaultValue={pageIndex + 1}
                              onChange={(e) => {
                                const pageNumber = e.target.value
                                  ? Number(e.target.value) - 1
                                  : 0;
                                gotoPage(pageNumber);
                              }}
                              style={{ width: "50px" }}
                            />
                          </span>
                        </div>

                        <div>
                          <button
                            style={{ background: "#0885ef" }}
                            className="btn btn_primary m-0"
                            type="button"
                            disabled={!canPreviousPage}
                            onClick={() => {
                              previousPage();
                            }}
                          >
                            Prev
                          </button>

                          <button
                            style={{ background: "#0885ef" }}
                            className="btn btn_primary m-0 ms-2"
                            type="button"
                            disabled={!canNextPage}
                            onClick={() => {
                              nextPage();
                            }}
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </ThemeProvider>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default withRouter(MediumMaster);
